import { render, staticRenderFns } from "./FreeWriting.vue?vue&type=template&id=6dd13376&"
import script from "./FreeWriting.vue?vue&type=script&lang=js&"
export * from "./FreeWriting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FreeWriting.vue"
export default component.exports